import { OrganizationDto } from '@sib/api';
import { OrganizationLogoContent } from './OrganizationLogoContent';

interface OrganizationLogoProps {
  organization?: OrganizationDto;
}

enum OrganizationLogoKey {
  NoOrganization = 'no-org',
  NoLogo = 'no-logo',
}

export const OrganizationLogo = ({ organization }: OrganizationLogoProps) => (
  <OrganizationLogoContent
    key={`${organization?.id ?? OrganizationLogoKey.NoOrganization}-${organization?.fileUrl ?? OrganizationLogoKey.NoLogo}`}
    organization={organization}
  />
);
